import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '../analytics'

export default {
  headline: 'Introducing Priceline Experiences',
  subheadline:
    'Discover and book over 80,000 in-destination travel activities in more than 100 countries worldwide!',
  badgeText: 'NEW!',
  callToAction: {
    text: 'Explore Now',
    url: 'https://experiences.priceline.com/?cid=hpgbanner',
    ariaLabel: 'marketingCTA'
  },
  onClick: () => {
    analytics.fireEvent({
      action: 'branded marketing component',
      category: ANALYTICS_CATEGORY_HOME,
      label: 'experiences click'
    })
  },
  imageUrl:
    'https://s1.pclncdn.com/design-assets/brand-assets/experiences1.jpg?opto&auto=avif,webp&crop=600,420,x200,safe,smart'
}
